module.exports = __webpack_public_path__ + "static/media/zola.b55144fe.gif";